import { render, staticRenderFns } from "./edutalk-qrcode.vue?vue&type=template&id=746f0ce9"
import script from "./edutalk-qrcode.vue?vue&type=script&lang=js"
export * from "./edutalk-qrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports